module.exports = __webpack_public_path__ + "media/hahah.e235166e.mp3";